module.exports = __webpack_public_path__ + "img/DSC_6945.437cc196.jpg";